import Vue from "vue";
import Router from "vue-router";
import Sidebar from "./layout/Sidebar";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Home from "./views/Home";
import Website from "./views/Website";
import Users from "./views/Users";
import DeletedUsers from "./views/DeletedUsers";
import Ideas from "./views/Ideas";
import News from "./views/News";
import CreateNew from "./views/CreateNews";
import Contacts from "./views/Contacts";
import Profile from "./views/Profile.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Project from "./views/Project.vue";
import addproject from "./views/ProjectNew.vue";
import ProjectTimeline from "./views/projectevents.vue";
import Events from "./views/Events";
import CreateEvent from "./views/CreateEvent";
import Testimonials from "./views/testimonials/testimonials";
import addtestimonials from "./views/testimonials/CreateTestimonials";
import updatetestimonials from "./views/testimonials/CreateTestimonials";
import Stories from "./views/success_stories/SuccessStories";
import AddStories from "./views/success_stories/CreateSuccessStories";
import UpdateStories from "./views/success_stories/CreateSuccessStories";
import Memberships from "./views/memberships/Memberships";
import AddMemberships from "./views/memberships/CreateMemberships";
import UpdateMemberships from "./views/memberships/CreateMemberships";
import Departments from "./views/departments/Departments";
import AddDepartments from "./views/departments/CreateDepartments";
import UpdateDepartments from "./views/departments/CreateDepartments";
import ManagementDepartments from "./views/managements/departments/Departments";
import AddManagementDepartments from "./views/managements/departments/CreateDepartments";
import UpdateManagementDepartments from "./views/managements/departments/CreateDepartments";
import Susteams from "./views/departments/susteams/Susteams";
import AddSusteams from "./views/departments/susteams/CreateSusteams";
import UpdateSusteams from "./views/departments/susteams/CreateSusteams";
import ManagementsTeams from "./views/managements/ManagementsTeams";
import AddManagementsTeams from "./views/managements/CreateManagementsTeamMembers";
import UpdateManagementsTeams from "./views/managements/CreateManagementsTeamMembers";
import NewsletterSubscribers from "./views/NewsletterSubscribers";

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/dashboard",
      name: "home",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website",
      name: "website",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Website,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/users",
      name: "website-users",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Users,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/users/deleted",
      name: "website-users-deleted",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: DeletedUsers,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/ideas",
      name: "website-ideas",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Ideas,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/events",
      name: "website-events",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Events,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/create-event",
      name: "website-create-event",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: CreateEvent,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/update-event/:event_id",
      name: "website-update-event",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: CreateEvent,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/news",
      name: "website-news",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: News,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/create-news",
      name: "website-create-news",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: CreateNew,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/update-news/:news_id",
      name: "website-update-news",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: CreateNew,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/contact-requests",
      name: "website-contacts",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Contacts,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/profile",
      name: "user-profile",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    },
    {
      path: "/",
      name: "login",
      components: {
        default: Login
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        default: Register
      }
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      components: {
        default: Login
      }
    },
    {
      path: "/dashboard/website/project",
      name: "website-project",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Project,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/project/new",
      name: "website-project-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: addproject,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/project/update/:pr_id",
      name: "website-project-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: addproject,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/project/timeline/:pr_id",
      name: "website-project-timeline",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: ProjectTimeline,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/testimonials",
      name: "website-testimonials",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Testimonials,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/testimonials/new",
      name: "website-testimonials-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: addtestimonials,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/testimonials/update/:testimonial_id",
      name: "website-testimonials-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: updatetestimonials,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/stories",
      name: "website-stories",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Stories,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/stories/new",
      name: "website-stories-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: AddStories,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/stories/update/:story_id",
      name: "website-stories-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: UpdateStories,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/memberships",
      name: "website-memberships",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Memberships,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/memberships/new",
      name: "website-memberships-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        // header: AppHeader,
        default: AddMemberships,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/memberships/update/:membership_id",
      name: "website-memberships-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: UpdateMemberships,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/departments",
      name: "website-departments",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Departments,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/departments/new",
      name: "website-departments-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: AddDepartments,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/departments/update/:department_id",
      name: "website-departments-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: UpdateDepartments,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/management-departments",
      name: "website-management-departments",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: ManagementDepartments,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/management-departments/new",
      name: "website-management-departments-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: AddManagementDepartments,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/management-departments/update/:department_id",
      name: "website-management-departments-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: UpdateManagementDepartments,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/susteams",
      name: "website-susteams",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: Susteams,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/susteams/new",
      name: "website-susteams-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: AddSusteams,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/susteams/update/:susteam_id",
      name: "website-susteams-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: UpdateSusteams,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/managements-teams",
      name: "website-managements-teams",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: ManagementsTeams,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/managements-teams/new",
      name: "website-managements-teams-add",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: AddManagementsTeams,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/managements-teams/update/:team_member_id",
      name: "website-managements-teams-update",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: UpdateManagementsTeams,
        footer: AppFooter
      }
    },
    {
      path: "/dashboard/website/newsletter-subscribers",
      name: "website-newsletter-subscribers",
      meta: { requiresAuth: true },
      components: {
        sidebar: Sidebar,
        header: AppHeader,
        default: NewsletterSubscribers,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const auth = localStorage.getItem("access_token");

    if (!auth) {
      next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
